// externals
import { createSelector } from 'reselect';

// libraries
import { selectors as offerReduxSelectors } from '@makemydeal/dr-offer-redux';
import { scopedStateSelectors } from '@makemydeal/shared-scoped-store';
import type { DealStructureContext } from '@makemydeal/dr-dash-bff-types';
import type { StateTree } from '@makemydeal/dr-dash-types';

// selectors
import { getPrimaryScopeState } from './primaryScopeSelectors';

// utils
import { buildDealStructureContextFromPrimaryScope } from '../utils/dealStructureContextBuilder';

export type DealStructureReadiness = 'ready' | 'loading' | 'calculating' | 'payment-failed' | 'missing-inputs';

const getPrimaryScopeId = (state: StateTree): string | undefined => scopedStateSelectors.getPrimaryScopeId(state as any);

export const getPrimaryDealStructureContext: (state: StateTree) => DealStructureContext | undefined = createSelector(
    [getPrimaryScopeState, getPrimaryScopeId],
    buildDealStructureContextFromPrimaryScope
);

export const getPrimaryDealStructureReadiness = (state: StateTree): DealStructureReadiness => {
    const primary = getPrimaryScopeState(state);
    if (!offerReduxSelectors.getOffer(primary).initialized) return 'loading';
    if (offerReduxSelectors.isCalculatingPayment(primary) || offerReduxSelectors.isAwaitingFreshPaymentResponse(primary)) {
        return 'calculating';
    }
    if (offerReduxSelectors.getIsError(primary)) return 'payment-failed';

    return getPrimaryDealStructureContext(state) ? 'ready' : 'missing-inputs';
};
